import { APICallV2Post } from './APICall';

export class MoveAPICall extends APICallV2Post {
    _method = 'file/move';
}
